// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel_Carousel__UbLTf"};